import { Box, SxProps, Theme, Typography } from '@mui/material';

interface StudioVaultTitleProps {
  title?: string;
  subtitle?: string;
  showSubtitle?: boolean;
  sx?: SxProps<Theme>;
  titleSx?: SxProps<Theme>;
}

export const StudioVaultTitle: React.FC<StudioVaultTitleProps> = ({
  title = 'STUDIO VAULT BETA!!',
  subtitle = 'Share, collaborate, and securely backup your music projects in the cloud',
  showSubtitle = true,
  sx,
  titleSx,
}) => {
  return (
    <Box sx={{ textAlign: 'center', mb: 2, position: 'relative', ...sx }}>
      <Typography
        variant="h1"
        component="h1"
        sx={{
          fontWeight: 900,
          mb: 1,
          whiteSpace: { xs: 'normal', sm: 'nowrap' },
          wordBreak: { xs: 'break-word', sm: 'normal' },
          textAlign: 'center',
          lineHeight: { xs: 1.15, sm: 1.2 },
          fontSize: {
            xs: 'clamp(1.8rem, 11vw, 2.4rem)',
            sm: '3rem',
            md: '4rem',
          },
          letterSpacing: { xs: '0.02em', sm: '0.06em' },
          color: 'text.primary',
          ...titleSx,
        }}
      >
        {title}
      </Typography>

      {showSubtitle && (
        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary',
            fontWeight: 400,
            fontSize: { xs: '0.75rem', sm: '1rem' },
            padding: { xs: '4px 10px', sm: '8px 16px' },
            borderRadius: '12px',
            bgcolor: 'background.paper',
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};
